/*
 * Copyright © 2026 Medaica, Inc
 *
 * All rights reserved.
 *
 * This code is confidential and proprietary information belonging to Medaica, Inc.
 * Unauthorized copying, distribution, or use of this code, in whole or in part,
 * is strictly prohibited, and may constitute a violation of intellectual property rights.
 *
 * If you have received this code in error, please notify the owner immediately
 * at support@medaica.com and delete this file from your system.
 */

import React, { ReactElement, ReactNode } from "react"
import BookingLayout from "./booking-layout"
import BookingStepper from "./booking-stepper"
import { BookingView } from "../stores/booking-ui-store"

/** Shared frame for the 4 wizard steps: chrome + the step pills + the step body. */
const WizardStepLayout = ({
  current,
  headerRight,
  children,
}: {
  current: BookingView
  headerRight?: ReactNode
  children: ReactNode
}): ReactElement => (
  <BookingLayout headerRight={headerRight}>
    <div className="max-w-4xl mx-auto px-6 py-8">
      <BookingStepper current={current} />
      <div className="mt-8">{children}</div>
    </div>
  </BookingLayout>
)

export default WizardStepLayout
